import { ShieldCheck, Award, Calendar } from 'lucide-react';
import { useT, useLang } from '@/lib/i18n';

interface LandingPageAuthorProps {
  dateModified: string;
}

export function LandingPageAuthor({ dateModified }: LandingPageAuthorProps) {
  const t = useT();
  const lang = useLang();
  const formatted = new Date(dateModified).toLocaleDateString(lang === 'en' ? 'en-US' : 'de-DE', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  return (
    <section className="border-t border-border/40 bg-muted/20 py-10">
      <div className="container mx-auto px-4">
        <div className="mx-auto max-w-3xl rounded-xl border border-border/60 bg-card p-6 md:p-8">
          <div className="flex flex-col gap-4 sm:flex-row sm:items-start">
            <div className="flex h-14 w-14 flex-shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
              <ShieldCheck className="h-7 w-7" aria-hidden="true" />
            </div>
            <div className="flex-1">
              <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">
                {t('Fachlich verantwortlich', 'Subject matter expert')}
              </p>
              <h2 className="mt-1 text-lg font-semibold text-foreground">
                {t('Lars Zimmermann, Geschäftsführer & KI-Manager', 'Lars Zimmermann, Managing Director & AI Manager')}
              </h2>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
                {t(
                  'KI Manager (IHK), Geprüfter Wirtschaftsfachwirt (IHK) und Meister Metallbau (HWK). 20 Jahre Industrieerfahrung im produzierenden Mittelstand. Die Inhalte dieser Seite basieren auf eigener Beratungspraxis bei KMU in Deutschland und werden regelmäßig an aktuelle Regulatorik und Technologie angepasst.',
                  'AI Manager (IHK), Certified Business Administrator (IHK) and Master Metal Construction (HWK). 20 years of industrial experience in the German manufacturing Mittelstand. The content of this page is based on hands-on consulting practice with SMEs in Germany and is regularly updated to reflect current regulation and technology.',
                )}
              </p>
              <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-muted-foreground">
                <span className="inline-flex items-center gap-1">
                  <Award className="h-3.5 w-3.5" aria-hidden="true" />
                  {t('KI Manager (IHK)', 'AI Manager (IHK)')}
                </span>
                <span className="inline-flex items-center gap-1">
                  <Calendar className="h-3.5 w-3.5" aria-hidden="true" />
                  {t(`Aktualisiert am ${formatted}`, `Updated on ${formatted}`)}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}